<template>
  <form @submit.prevent="submit">
    <ElCheckbox
      id="delete-account-check"
      v-model="confirmation"
      label="Ja, ich möchte meinen Account unwiderruflich löschen."
    />
    <div class="text-right mt-3">
      <AppButton
        :disabled="!confirmation"
        type="danger"
        native-type="submit"
      >
        Account löschen
      </AppButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElCheckbox } from 'element-plus';
import { ref } from 'vue';

import { deleteUser } from '@/api/user/userApi';
import { useRequest } from "@/api/lib/integration";

const confirmation = ref(false);
const { call } = useRequest(deleteUser, () => {
  window.location.replace('/');
})

const submit = async () => {
  await call(confirmation.value);
};
</script>
